export default __webpack_public_path__ + "static/media/acropass-applezone-temporary.4c23aa91.png";